
import React, { useEffect, useState } from "react";
import CustomButton from "./CustomButton";
import CustomTextAreaInput from "./admin/CustomTextAreaInput";
import CustomImageUpload from "./admin/CustomImageUpload";
import { Icon } from "@iconify/react";
import CustomButtonHtml from "./admin/CustomButtonHtml";

export default function CustomHtmlEditor({ initial, onChange }) {
  const [blockArray, setblockArray] = useState([]);
  const [SelectBlock, setSelectBlock] = useState(null);
  const addBlock = (number) => {
    let temp = [...blockArray];
    let newBlock = [];
    for (let i = 0; i < number; i++) {
      newBlock.push([]);
    }
    temp.push(newBlock);
    setblockArray(temp);
  };
  const setTypeBlock = (type) => {
    if (SelectBlock == null) {
      alert("please select block");
      return;
    }
    let BlockNo = SelectBlock.split("-");
    let selectBlockNo = parseInt(BlockNo[0]);
    let insideBlockNo = parseInt(BlockNo[1]);
    let temp = [...blockArray];
    temp[selectBlockNo][insideBlockNo] = {
      type: type,
      value: "",
    };
    setblockArray(temp);
  };
  const selectBlockFN = (selectBlockNo, insideBlockNo) => {
    setSelectBlock(selectBlockNo + "-" + insideBlockNo);
  };
  const onChangeTextBlock = (text,fromBlock) => {
    let BlockNo = fromBlock.split("-");
    let selectBlockNo = parseInt(BlockNo[0]);
    let insideBlockNo = parseInt(BlockNo[1]);
    let temp = [...blockArray];
    temp[selectBlockNo][insideBlockNo].value = text;
    setblockArray(temp);
  };
  const onChangeImageBlock = (file,fromBlock) => {
    if(fromBlock){
      let BlockNo = fromBlock.split("-");
      let selectBlockNo = parseInt(BlockNo[0]);
      let insideBlockNo = parseInt(BlockNo[1]);
      console.log("BlockNo", BlockNo);
      let temp = [...blockArray];
      console.log("blockArray", blockArray);
      if (file) {
        temp[selectBlockNo][insideBlockNo].path = URL.createObjectURL(file);
        temp[selectBlockNo][insideBlockNo].value = file;
      } else {
        temp[selectBlockNo][insideBlockNo].path = null;
        temp[selectBlockNo][insideBlockNo].value = null;
      }
      console.log("temp", temp);
      setblockArray(temp);
    }
  };
  const onDeleteBlock = () => {
    let BlockNo = SelectBlock.split("-");
    let selectBlockNo = parseInt(BlockNo[0]);
    let insideBlockNo = parseInt(BlockNo[1]);
    let temp = [...blockArray];
    if(temp[selectBlockNo].length>1){
      temp[selectBlockNo].splice(insideBlockNo,1)
    }else{
      temp.splice(selectBlockNo,1)
    }
    setblockArray(temp);
    setSelectBlock(null);
  };
  useEffect(() => {
    if (onChange != null) {
      onChange(blockArray);
    }
  }, [blockArray]);
  useEffect(() => {
    if(initial?.length>0){
      setblockArray(initial)
    }
  }, [])
  
  return (
    <div className="h-full z-0">
      <div className="grid grid-cols-3 gap-8 h-full">
        <div className="col-span-2 border p-3 flex flex-col gap-3 w-full overflow-y-scroll">
          {blockArray.map((item, i) => {
            return (
              <div key={i}>
                <div className={"grid gap-3 w-full grid-flow-col "}>
                  {item.map((data, j) => {
                    return (
                      <div
                        key={j}
                        className={
                          "border bg-slate-100 rounded-lg drop-shadow-sm min-w-[150px] p-1 " +
                          (SelectBlock == i + "-" + j
                            ? "border-[#B36427]"
                            : "") +
                          (data.type == "text"
                            ? " min-h-[300px] "
                            : " min-h-[50px] ")
                        }
                        onClick={() => {
                          selectBlockFN(i, j);
                        }}
                      >
                        {data.type != undefined ? (
                          data.type == "text" ? (
                            <CustomTextAreaInput
                              value={data.value}
                              onChange={(value)=>onChangeTextBlock(value,i + "-" + j)}
                            />
                          ) : data.type == "image" ? (
                            <CustomImageUpload
                              name={"inputFile" + i + "-" + j}
                              value={data.value}
                              path={data.path}
                              onChange={(file)=>onChangeImageBlock(file,i + "-" + j)}
                            />
                          ) : null
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <div className="flex flex-col gap-3 bg-[#F9F9F9] p-3 h-full justify-start ">
          <div>
            <p>Add Column</p>
            <div className="grid grid-cols-3 gap-3">
              <CustomButtonHtml
                icon={"uim:square"}
                title={"1 Column"}
                onClickBtn={() => {
                  addBlock(1);
                }}
              />
              <CustomButtonHtml
                icon={"uis:columns"}
                title={"2 Column"}
                onClickBtn={() => {
                  addBlock(2);
                }}
              />
              <CustomButtonHtml
                icon={"uis:grids"}
                title={"3 Column"}
                onClickBtn={() => {
                  addBlock(3);
                }}
              />
            </div>
          </div>
          <div>
            <p>Type Column</p>
            <div className="grid grid-cols-3 gap-3">
              <CustomButtonHtml
                icon={"uil:text-fields"}
                title={"Text"}
                onClickBtn={() => {
                  setTypeBlock("text");
                }}
              />
              <CustomButtonHtml
                icon={"uil:image-v"}
                title={"Image"}
                onClickBtn={() => {
                  setTypeBlock("image");
                }}
              />
            </div>
          </div>
          {SelectBlock ? (
            <CustomButton
              txt={"Delete Column"}
              leftIconName={"uim:square"}
              classAdditional="text-center"
              bgcolor="#9E0400"
              onClick={() => {
                onDeleteBlock();
              }}
            />
          ) : null}
          <div className="">
            <CustomButton
              txt={"Reset"}
              leftIconName={"uis:redo"}
              classAdditional="text-center"
              bgcolor="#9E0400"
              onClick={() => {
                setblockArray([]);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
